const flagsStore: string[] = []

export const flagEnabled = (featureKey: string): boolean => {
  return flagsStore.includes(featureKey)
}

export const setEnabledFlags = (flags: string[]): void => {
  flagsStore.length = 0
  flagsStore.push(...flags)
}
